import { Navigate } from "react-router-dom";
import { Show } from "@clerk/react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import AuthTokenInjector from "@/components/auth/AuthTokenInjector";
import { I18nProvider } from "@/lib/i18n";
import Dashboard from "@/pages/Dashboard";
import SignInPage from "@/pages/SignInPage";
import SignUpPage from "@/pages/SignUpPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <I18nProvider>
          <ClerkAuthProvider>
            <AuthTokenInjector />
            <Routes>
              <Route
                path="/"
                element={
                  <>
                    <Show when="signed-in">
                      <Dashboard />
                    </Show>
                    <Show when="signed-out">
                      <Navigate to="/sign-in" replace />
                    </Show>
                  </>
                }
              />
              <Route
                path="/sign-in/*"
                element={<SignInPage />}
              />
              <Route
                path="/sign-up/*"
                element={<SignUpPage />}
              />
            </Routes>
          </ClerkAuthProvider>
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
